import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Input, Tooltip } from 'antd';

import './FormLabelWithField.less';

const FormLabelWithField = ({
  label,
  isRequired,
  helperText,
  className,
  children,
  ...otherProps
}) => {
  return (
    <TextFieldWithLabel
      className={
        'text-field-with-label--container' + (className != undefined ? ' ' + className : '')
      }
    >
      <div className="text-field-with-label--label-container">
        <label className={'text-field-with-label--label' + (isRequired ? ' required' : '')}>
          {label}
          {helperText != '' && (
            <Tooltip placement="top" title={helperText}>
              <span className="text-field-with-label--helper">?</span>
            </Tooltip>
          )}
        </label>
      </div>
      {children && <div className="text-field-with-label--input-container">{children}</div>}
    </TextFieldWithLabel>
  );
};

FormLabelWithField.propTypes = {
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  helperText: PropTypes.string,
};

FormLabelWithField.defaultProps = {
  label: '',
  isRequired: false,
  helperText: '',
};

const TextFieldWithLabel = styled.div`
  font-family: Sofia Pro;

  .text-field-with-label--label-container {
    display: flex;

    .text-field-with-label--label {
      font-weight: bold;
      font-size: 20px;
      line-height: 120%;
      letter-spacing: -0.01em;
      color: var(--normal-title-color);

      &:before {
        content: ' ';
      }
    }

    .text-field-with-label--label.required {
      &:before {
        content: '*';
        padding-right: 5px;
      }
    }

    .text-field-with-label--helper {
      width: 20px;
      height: 20px;
      min-width: 20px;
      min-height: 20px;
      display: inline-block;
      border-radius: 50%;
      background: var(--blue-6);
      font-weight: bold;
      font-size: 13px;
      line-height: 22px;
      text-align: center;
      color: var(--white-color);
      margin-left: 10px;
      cursor: pointer;
      vertical-align: top;
    }
  }

  .text-field-with-label--input-container {
    margin-top: 15px;

    & > div {
      width: 100%;
      margin-top: 0;
      height: 100%;
    }

    input {
      height: 58px;
      border: 1px solid #cfd8dc;
      box-sizing: border-box;
      border-radius: 0;
      font-size: 18px;
      width: 100%;
      padding: 0 23px;
    }

    .ant-select {
      .ant-select-selector {
        height: 100%;
        border-radius: 0;
        border: 1px solid #cfd8dc;
      }
    }
  }

  @media (max-width: 768px) {
    .text-field-with-label--label-container {
      .text-field-with-label--label {
        font-size: 18px;
      }
    }

    .text-field-with-label--input-container {
      input {
        height: 48px;
      }
    }
  }

  @media (max-width: 576px) {
  }
`;

export default FormLabelWithField;
